import { useEffect } from "react";

export default function Redirect() {

    useEffect(() => {
        const location = window.location.href;

        console.log(location);
        if (location.includes("southdallas")) {
            console.log("redirecting to south dallas");
            window.location.href = "https://order.hendersonchicken.com/menu/south_dallas";
        } else if (location.includes("northdallas")) {
            return;
        } else if (location.includes("westdallas")) {
            window.location.href = "https://order.hendersonchicken.com/menu/west_dallas";
        } else if (location.includes("eastoakcliff")) {
            window.location.href = "https://order.hendersonchicken.com/menu/east_oak_cliff";
        } else if (location.includes("westoakcliff")) {
            window.location.href = "https://order.hendersonchicken.com/menu/west_oak_cliff";
        } else if (location.includes("desoto")) {
            window.location.href = "https://order.hendersonchicken.com/menu/desoto";
        } else if (location.includes("lancaster")) {
            window.location.href = "https://order.hendersonchicken.com/menu/lancaster";
        } else if (location.includes("pleasantgrove")) {
            window.location.href = "https://order.hendersonchicken.com/menu/pleasant_grove";
        } else {
            window.location.href = "https://order.hendersonchicken.com/menu";
        }
    }, []);

    return <div>Redirecting...</div>;

}